import React, {useState} from 'react';
import {useLocation} from '@reach/router';
import Controls from 'components/Controls';
import {Form, Formik} from 'formik';

import {useSubscribe} from './mutation';
import {validationSchema} from './schema';

import * as styles from './styles.module.scss';

const Subscribe = () => {
	const location = useLocation();

	const [subbed, setSubbed] = useState<boolean>(false);
	const [subscribe] = useSubscribe({
		onCompleted: () => setSubbed(true),
	});

	const onSubmit = (values: {email: string}) => {
		subscribe({
			variables: {
				email: values.email,
				path: location.pathname,
			},
		});
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>Join our Newsletter</div>
			<div className={styles.content}>
				{subbed && (
					<div className={styles.success}>
						<div>You're in!</div>
						<div>
							Keep an eye for our inbox for news,
							tips, and more to support you on your
							health journey.
						</div>
					</div>
				)}
				{!subbed && (
					<Formik
						initialValues={{email: ''}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}
					>
						{() => (
							<Form className={styles.form}>
								<Controls.Text name='email' placeholder='Email' />
								<Controls.Submit variant='light'>
									Subscribe
								</Controls.Submit>
							</Form>
						)}
					</Formik>
				)}
			</div>
		</div>
	);
};

export default Subscribe;
